import * as React from 'react'
import { connect, Dispatch } from 'react-redux'
import { ChildProps } from 'react-apollo'

import { Store } from '../../../reducers/index'
import {
  getActiveCase,
  EditableCase,
  getActiveCategory
} from '../../../reducers/project'

import BeamEditor from './Editors/BeamEditor'
import { withFormData, FormDataResponse } from './formDataQueries'
import SlabEditor from './Editors/SlabEditor'
import LoadEditor from './Editors/LoadEditor'
import SpaceTypeEditor from './Editors/SpaceTypeEditor'
import LocationEditor from './Editors/LocationEditor'
import { selectNextCaseItem } from '../../../actions/project'
import { Action } from '../../../actions/types'

type Props = {
  activeCase: EditableCase | undefined
  activeCategory: string | undefined
  next: () => Action
}

class NewEditorArea extends React.Component<
  ChildProps<Props, FormDataResponse>
> {
  render() {
    
    const data = this.props.data
    if (!data || data.loading) {
      return null
    }

    if (
      !data.beamTypes ||
      !data.slabTypes ||
      !data.beamConcreteGrades ||
      !data.fireResistances ||
      !data.spaceTypes
    ) {
      return null
    }

    if (!this.props.activeCase) {
      return null
    }

    const caseId = this.props.activeCase.id

    if (this.props.activeCategory === 'location') {
      return <LocationEditor key={caseId} />
    } else if (this.props.activeCategory === 'spacetype') {
      return <SpaceTypeEditor spaceTypes={data.spaceTypes} key={caseId} />
    } else if (this.props.activeCategory === 'beams') {
      return (
        <BeamEditor
          onSubmit={this.props.next}
          beamTypes={data.beamTypes}
          concreteGrades={data.beamConcreteGrades}
          fireResistances={data.fireResistances}
          key={caseId}
        />
      )
    } else if (this.props.activeCategory === 'slabs') {
      return (
        <SlabEditor
          onSubmit={this.props.next}
          slabTypes={data.slabTypes}
          key={caseId}
        />
      )
    } else if (this.props.activeCategory === 'loads') {
      return (
        <LoadEditor
          onSubmit={this.props.next}
          spaceTypes={data.spaceTypes}
          key={caseId}
          topConcrete={this.props.activeCase.slabs[0].topConcrete}
        />
      )
    } else {
      return null
    }
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  activeCase: getActiveCase(state),
  activeCategory: getActiveCategory(state)
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  next: () => dispatch(selectNextCaseItem())
})

export default withFormData(
  connect(mapStateToProps, mapDispatchToProps)(NewEditorArea)
)



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/EditorArea.tsx